import type { Control } from 'react-hook-form';
import { parseDate } from '../../../common/functions/parse-date';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { OdinCalendarProps } from './calendar.component';
import OdinCalendar from './calendar.component';

export interface HfDateProps extends OdinCalendarProps {
  control: Control;
  name: string;
}

export default function HfDate({
  control,
  name,
  label,
  readOnly,
  required,
  onChange,
  fieldValueConverter,
  disabled,
  fieldValidations,
  labelStyles,
}: HfDateProps) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange: handleChange, value }, fieldState: { error } }) => {
        return (
          <OdinCalendar
            label={label}
            value={value instanceof Date ? value : parseDate(value)}
            error={error?.message}
            onChange={handleChange}
            readOnly={disabled || readOnly}
            required={required}
            labelStyles={labelStyles}
            fieldValidations={fieldValidations}
            showButtonBar
          />
        );
      }}
    />
  );
}
